/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Label, Input, Col } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import ErrorBoundary from '../general/ErrorBoundary';
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

const AddProvider = props => {

    // states
    const [provider, setProvider] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: ''
    });
    const [newProviders, setNewProviders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // contexts
    const { theme } = useContext(ThemeContext);

    //useEffect
    useEffect(() => {
        AdminService.getNewProviders().then(data => {
            setNewProviders(data.providers);
        }).catch(error => {
            Alert.error(error.message.msgBody, {
                position: 'top-right',
                effect: 'slide'
            });
        })
    }, []);


    // handle functions
    const handleChange = e => {
        try {
            if (e.target.name === "select") {
                const email = newProviders[e.target.value].email;
                const name = newProviders[e.target.value].name.split(" ");
                const firstName = name[0] ? name[0] : "";
                const lastName = name[1] ? name[1] : "";
                setProvider({ email: email, firstName: firstName, lastName: lastName, password: "" });
            } else {
                setProvider({ ...provider, [e.target.name]: e.target.value });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddProvider hadleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading(true);
            AdminService.registerProvider(provider)
                .then(data => {
                    const index = document.getElementById("select").value;
                    let tempArray = [...newProviders];
                    tempArray.splice(index, 1);
                    setNewProviders(tempArray);
                    document.getElementById("select").value = "";
                    setProvider({ email: '', password: '', firstName: '', lastName: '' });
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddProvider hadleSubmit', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Add Counsellor</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        Create a new Counsellor account
                    </div>
                    <div className="card-body">
                        <ErrorBoundary errorAt="At Admin AddProvider Form">
                            <Form onSubmit={handleSubmit}>
                                <label className="mb-4">
                                    Enter the email and an initial password for the counsellor. The counsellor will be notified with the given credentials through automated email service.<br />You can select counsellor who requested for signup from the dropdown or can enter details manually.
                                </label>
                                <FormGroup row>
                                    <Label sm={3} for="select">Select one</Label>
                                    <Col sm={6}>
                                        <Input type="select" name="select" id="select" onChange={handleChange}>
                                            <option value="">Select</option>
                                            {
                                                newProviders.map((item, index) => (
                                                    <option key={index} value={index}>{item.email}</option>
                                                ))
                                            }
                                        </Input>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={3} for="FirstName">First Name</Label>
                                    <Col sm={6}>
                                        <Input type="text" name="firstName" id="firstName" value={provider.firstName} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={3} for="lastName">Last Name</Label>
                                    <Col sm={6}>
                                        <Input type="text" name="lastName" id="lastName" value={provider.lastName} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={3} for="email">Counsellor Email</Label>
                                    <Col sm={6}>
                                        <Input type="email" name="email" id="email" value={provider.email} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={3} for="password">Initial Password</Label>
                                    <Col sm={6}>
                                        <Input type="text" name="password" id="password" value={provider.password} onChange={handleChange} required />
                                    </Col>
                                </FormGroup>
                                <Button type="submit" className="btn mt-2" style={theme.button} disabled={isLoading}>
                                    {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Add Counsellor
                                </Button>
                            </Form>
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        </main>
    )

}

export default AddProvider;